/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'ck-ui';
import { trackCustomEventThenRedirect } from 'ck-utils/algoliaAnalytics';
import styles from './ProductHit.module.scss';

const ProductFeatureTile = ({ featureTile }) => {
  const {
    image,
    gaTracking,
    href,
  } = featureTile;
  const collectionHandle = window.location.pathname.split('/').filter(x => x && x !== 'collections')[0];

  useEffect(() => {
    if (collectionHandle && gaTracking) {
      window.dataLayer.push({
        event: 'gaEvent',
        gaEvent: {
          name: 'featureTileView',
          category: 'Feature Tile',
          action: 'view',
          label: `${collectionHandle} > ${gaTracking}`,
        },
      });
    }
  }, [collectionHandle, gaTracking]);

  const trackTileClick = url => e => {
    e.preventDefault();

    trackCustomEventThenRedirect({
      event: 'gaEvent',
      url,
      data: {
        gaEvent: {
          name: 'featureTileClick',
          category: 'Feature Tile',
          action: 'Click',
          label: `${collectionHandle} > ${gaTracking}`
        }
      }
    });
  };

  return (
    <div className="column is-half-tablet is-one-third-desktop">
      <div className={styles.root}>
        <a
          title={gaTracking}
          href={href}
          onClick={trackTileClick(href)}
          className="product-tile-image-wrapper"
        >
          <LazyLoadImage alt={gaTracking} src={`https://${image}?auto=format,compress`} />
        </a>
      </div>
    </div>
  );
};

ProductFeatureTile.propTypes = {
  featureTile: PropTypes.object,
};

export { ProductFeatureTile };
